declare var Unity: any;

export default class UnityBridge {
    private eventListeners = new Array();

    public send(message: string, data?: any) {
        if (data) {
            if (typeof data === 'object') {
                message += ' ' + JSON.stringify(data);
            } else {
                message += ' ' + data;
            }
        }

        if (typeof Unity !== 'undefined' && Unity.call) {
            Unity.call(message);
        }
    }

    public addMessageHandler(msgType: string, handler: EventListener) {
        this.eventListeners.push([msgType, handler]);
        document.addEventListener(msgType, handler);
    }

    public destroy() {
        this.eventListeners.forEach(listener => {
            document.removeEventListener(listener[0], listener[1]);
        });
    }
}
